import { GatheringDetailPage } from './gathering-detail-page';

export const ProgramDetailPage = () => <GatheringDetailPage kind="program" />;
